const DashboardRoutes = [
]

export default DashboardRoutes
